import { SET_CREATE_BOOKING_RESPONSE } from '../actions/createBookingActions';

const initialState = null

const createBookingReducer = (state = initialState, action) => {
    switch (action.type) {
      case SET_CREATE_BOOKING_RESPONSE:
        return action.payload;
      default:
        return state;
    }
  };
  
  export default createBookingReducer;
  